"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Practices = exports.PracticeDropdown = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PracticeDropdown = function PracticeDropdown(_ref) {
  var clients = _ref.clients,
    handleChange = _ref.handleChange,
    type = _ref.type,
    isMedicalMarket = _ref.isMedicalMarket;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    practice = _useState2[0],
    setPractice = _useState2[1];
  var text = type === 'group' ? 'Groups' : "".concat(isMedicalMarket ? 'Practices' : 'Centers');
  var handlePracticeChange = function handlePracticeChange(event) {
    setPractice(event.target.value);
    handleChange(event);
  };
  var getDisplayName = function getDisplayName(_ref2) {
    var name = _ref2.name,
      cityName = _ref2.cityName,
      stateName = _ref2.stateName;
    if (type === 'practice') {
      if (cityName && stateName) {
        return "".concat(name, " (").concat(cityName, ", ").concat(stateName, ")");
      } else if (cityName || stateName) {
        return "".concat(name, " (").concat(cityName ? cityName : stateName, ")");
      }
    }
    return name;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form__practice_container"
  }, /*#__PURE__*/_react.default.createElement("select", {
    "data-test-id": "practice-selector",
    className: "form__practice",
    onChange: handlePracticeChange,
    value: practice
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }, "All ", text), clients.map(function (client) {
    return {
      id: client.id,
      displayName: getDisplayName(client)
    };
  }).sort(function (a, b) {
    return a.displayName.localeCompare(b.displayName);
  }).map(function (_ref3) {
    var id = _ref3.id,
      displayName = _ref3.displayName;
    return /*#__PURE__*/_react.default.createElement("option", {
      key: id,
      value: id
    }, displayName);
  })));
};
exports.PracticeDropdown = PracticeDropdown;
var Practices = function Practices(_ref4) {
  var groupOrCorpClients = _ref4.groupOrCorpClients,
    orgType = _ref4.orgType,
    fetchPlans = _ref4.fetchPlans,
    onGroupChange = _ref4.onGroupChange,
    isMedicalMarket = _ref4.isMedicalMarket;
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    practicesByGroup = _useState4[0],
    setPracticesByGroup = _useState4[1];
  var handleGroupChange = function handleGroupChange(event) {
    var selectedGroupId = event.target.value;
    var allGroups = groupOrCorpClients.organization;
    if (selectedGroupId) {
      var selectedGroup = allGroups.find(function (_ref5) {
        var id = _ref5.id;
        return id === parseInt(selectedGroupId, 10);
      });
      if (selectedGroup) {
        setPracticesByGroup(selectedGroup.organization);
      }
    } else {
      setPracticesByGroup([]);
    }
    onGroupChange();
  };
  var handlePracticeChange = function handlePracticeChange(event) {
    var selectedPracticeId = event.target.value;
    fetchPlans(selectedPracticeId);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group col-xs-12 col-sm-4 col-md-5"
  }, /*#__PURE__*/_react.default.createElement(PracticeDropdown, {
    type: orgType === 'corporation' ? 'group' : 'practice',
    handleChange: orgType === 'corporation' ? handleGroupChange : handlePracticeChange,
    clients: groupOrCorpClients.organization,
    isMedicalMarket: isMedicalMarket
  }), practicesByGroup && practicesByGroup.length > 0 && /*#__PURE__*/_react.default.createElement(PracticeDropdown, {
    type: "practice",
    handleChange: handlePracticeChange,
    clients: practicesByGroup,
    isMedicalMarket: isMedicalMarket
  }));
};
exports.Practices = Practices;
Practices.defaultProps = {
  groupOrCorpClients: {}
};
Practices.propTypes = {
  groupOrCorpClients: _propTypes.default.object,
  orgType: _propTypes.default.string,
  fetchPlans: _propTypes.default.func,
  onGroupChange: _propTypes.default.func,
  isMedicalMarket: _propTypes.default.bool
};
PracticeDropdown.propTypes = {
  clients: _propTypes.default.arrayOf(_propTypes.default.object),
  handleChange: _propTypes.default.func,
  type: _propTypes.default.string,
  isMedicalMarket: _propTypes.default.bool
};
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator/dist/client/components/scss/index.scss');